import { NotePlusOutlineIcon } from './NotePlusOutlineIcon';

/**
 * author: Austin Andrews
 * id 706F4C63-412B-44CD-81DE-612D4483D09C
 * name note-plus-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-plus-outline.svg
 * tags
 */
export const StickyNoteAddOutlineIcon = NotePlusOutlineIcon;
export default StickyNoteAddOutlineIcon